// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3ukUVSjUq0DMC5z-KjegFq{display:flex;flex-direction:column;padding:3.2rem 2.4rem}._2fQs0x_l9xBLOQSp0LnzxF,._1LN_2D2Qesu9eGPZotsUFe{flex-basis:45%}.nwSypc1tbtos18FMEcTdD{margin-top:3rem}@media (min-width:768px){._3ukUVSjUq0DMC5z-KjegFq{flex-direction:row;justify-content:space-between}}@media (min-width:1200px){._3ukUVSjUq0DMC5z-KjegFq{flex-direction:column}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "_3ukUVSjUq0DMC5z-KjegFq",
	"charactesticsBloc": "_2fQs0x_l9xBLOQSp0LnzxF",
	"statsWrapper": "_1LN_2D2Qesu9eGPZotsUFe",
	"stats": "nwSypc1tbtos18FMEcTdD"
};
module.exports = ___CSS_LOADER_EXPORT___;
